/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemTileCarousel_item = {
    readonly " $fragmentRefs": FragmentRefs<"ItemTileBase_item" | "ProductCarousel_item">;
    readonly " $refType": "ItemTileCarousel_item";
};
export type ItemTileCarousel_item$data = ItemTileCarousel_item;
export type ItemTileCarousel_item$key = {
    readonly " $data"?: ItemTileCarousel_item$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemTileCarousel_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ItemTileCarousel_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "isTrade",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "showSeller",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "pageDisplayEnum",
      "type": "PageDisplayEnum",
      "defaultValue": "searchAndBrowse"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ItemTileBase_item",
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "pageDisplayEnum",
          "variableName": "pageDisplayEnum"
        },
        {
          "kind": "Variable",
          "name": "showSeller",
          "variableName": "showSeller"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ProductCarousel_item",
      "args": null
    }
  ]
};
(node as any).hash = 'a0521ef89021ab407f38f823afcf9de7';
export default node;
